import {
  DataI,
  HeroSectionDataI,
  RegisterFormSectionDataI,
  ShyftPassDataI,
  WorkoutScheduleSectionDataI,
  BenefitsSectionDataI,
} from "./shyftPassMaps";

const mapHeroSectionData = (data: DataI): HeroSectionDataI => {
  const { hero } = data || {};

  const heroSectionData = {
    title_1: "Weekend Workouts",
    title_2: "Community Mixers",
    title_3: "Wellness Products",
    subtitle: "Join the ultimate health & wellness community",
    description_1:
      "A single membership that gives you access to a variety of weekend workouts at handpicked studios in your neighbourhood, along with wellness mixers with a like minded community, and access to the latest wellness products.",
    description_2: "Exclusively for the age group of 30-45yrs.",
    card_data: {
      left_text: "EXCLUSIVE MEMBER",
      validity_text: "Valid for 1 month",
      bg_image:
        "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/shyft-card-image-4.png",
    },
    ctaTitle: hero?.hero_cta_title_secondary,
  } as HeroSectionDataI;

  return heroSectionData;
};

const mapBenefitsSectionData = (data: DataI): BenefitsSectionDataI => {
  const { benefits } = data || {};

  const BenefitsSectionData = {
    title: "Benefits & how to use the membership",
    benefits_data: [
      {
        content:
          "Download the app to stay updated on the Shyft Pass workout schedule, community events and Shyft Pass benefits.",
        have_app_download_link: true,
      },
      {
        content:
          "Once you are a Shyft pass member, you are eligible to attend any of our weekend workouts (1 workout per weekend). You can always see the schedule of the next 4 weeks via the app.",
        have_app_download_link: false,
      },
      {
        content:
          "We hold exclusive mixers for our member where experts from the wellness space come forward to share their knowledge and answer questions!",
        have_app_download_link: false,
      },
      {
        content:
          "Our Shyft Pass members also get exclusive access to the latest products from our wellness brand partners!",
        have_app_download_link: false,
      },
    ],
  } as BenefitsSectionDataI;

  return BenefitsSectionData;
};

const mapWorkoutScheduleSectionData = (
  data: DataI
): WorkoutScheduleSectionDataI => {
  const { services } = data || {};

  const workoutScheduleSectionData = {} as WorkoutScheduleSectionDataI;

  workoutScheduleSectionData.title = services?.title;
  workoutScheduleSectionData.description =
    services?.description ||
    "At any point, we publish schedule for the next 4 weeks. Exercises are customized to suit individuals with different degrees of physical readiness.<br/><br/>Use the toggle below to move between the schedules for Gurgaon and Delhi. ";

  return workoutScheduleSectionData;
};

const mapRegisterFormSectionData = (data: DataI): RegisterFormSectionDataI => {
  const { forms, package_info } = data || {};

  const registerFormSectionData = {} as RegisterFormSectionDataI;

  registerFormSectionData.title = forms?.sub_title;

  registerFormSectionData.showNameField = forms?.show_name_field;
  registerFormSectionData.namePlaceholder = forms?.name_placeholder;

  registerFormSectionData.showPhoneField = forms?.show_phone_field;
  registerFormSectionData.phonePlaceholder = forms?.phone_placeholder;

  registerFormSectionData.showEmailField = forms?.show_email_field;
  registerFormSectionData.emailPlaceholder = forms?.email_placeholder;

  registerFormSectionData.showCityField = forms?.show_city_field;
  registerFormSectionData.cityPlaceholder = forms?.city_placeholder;

  registerFormSectionData.showPackages = forms?.show_packages_field;
  registerFormSectionData.packagePlaceholder = forms?.package_placeholder;

  registerFormSectionData.showRequestCallback = forms?.request_callback;

  registerFormSectionData.showStartDateField = forms?.show_start_date_field;

  registerFormSectionData.info = forms?.bottom_title;
  registerFormSectionData.offerEndDate = forms?.meta?.offer_end_date;
  registerFormSectionData.showOfferCounter = forms?.meta?.show_offer_details;

  registerFormSectionData.offerTextFirstPart =
    forms?.meta?.offer_text?.split(":")[0] + " " + ":";
  registerFormSectionData.offerTextSecondPart =
    " " + forms?.meta?.offer_text?.split(":")[1];

  registerFormSectionData.packages = package_info?.map(
    ({
      title,
      duration,
      strikeout_price,
      price,
      slug,
      currency_code,
      currency_symbol,
      meta_tag_json,
    }) => ({
      title,
      duration,
      price,
      strikeoutPrice: strikeout_price,
      slug,
      currencyCode: currency_code,
      currencySymbol: currency_symbol,
      metaTagData: {
        displayHeading: meta_tag_json?.display_heading || "",
        displaySubHeading: meta_tag_json?.display_sub_heading || "",
        ranking:
          typeof meta_tag_json?.ranking !== "undefined"
            ? meta_tag_json?.ranking
            : Number.MAX_VALUE,
        isNewPackage: meta_tag_json?.tag || false,
      },
    })
  );

  // sort the package in the increasing order of ranking in metaTagData;
  registerFormSectionData.packages = registerFormSectionData.packages.sort(
    (a, b) => a.metaTagData.ranking - b.metaTagData?.ranking
  );

  registerFormSectionData.defaultPackageSlug = "shyft_pass";

  return registerFormSectionData;
};

const mapShyftPassData = (data: DataI): ShyftPassDataI => {
  const shyftPassData = {} as ShyftPassDataI;

  shyftPassData.hero = mapHeroSectionData(data);
  shyftPassData.benefits = mapBenefitsSectionData(data);
  shyftPassData.workoutSchedule = mapWorkoutScheduleSectionData(data);
  shyftPassData.form = mapRegisterFormSectionData(data);
  shyftPassData.faqs = {};

  return shyftPassData;
};

export default mapShyftPassData;
